import { AnimatePresence, motion } from "framer-motion";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

// INTERFACES
import { AppState } from "../../store/reducer";

// ASSETS
import headerVideo from "../../assets/videos/header_nurasign.mp4";
import { HeaderState, transition } from "./HeaderUtils";
import HeaderRight from "./HeaderRight";
import HeaderLeft from "./HeaderLeft";
import HeaderDate from "./HeaderDate";
import "./Header.scss";

export default function Header() {
	const headerState: HeaderState = useSelector((state: AppState) => state.headerState);

	return (
		<motion.div
			className="header"
			transition={transition}
			animate={
				headerState === HeaderState.Collapse ? { height: "65px" } : { height: "180px" }
			}
			initial={false}
		>
			<video
				className="video"
				autoPlay
				loop={true}
				muted
			>
				<source
					src={headerVideo}
					type="video/mp4"
				/>
			</video>
			<Box>
				<AnimatePresence
					mode="popLayout"
					initial={false}
				>
					<HeaderLeft />
				</AnimatePresence>
			</Box>

			<AnimatePresence
				mode="wait"
				initial={false}
			>
				<HeaderDate />
			</AnimatePresence>

			<AnimatePresence
				mode="popLayout"
				initial={false}
			>
				<HeaderRight />
			</AnimatePresence>
		</motion.div>
	);
}
